import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/transportadora/actions';

import Form from './form';

function Transportadora() {
  const redux = useSelector((state) => state.transportadora);

  const header = useMemo(
    () => [
      {
        id: 'cnpjtransportadoranfe',
        label: t('s.configuracao.posto.cnpjposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nometransportadoranfe',
        label: t('s.configuracao.posto.nomeposto'),
        filter: {
          type: 'text',
        },
      },
    ],
    []
  );

  const fieldlist = ['cnpjtransportadoranfe', 'nometransportadoranfe'];

  const substituirHeader = {
    cnpjtransportadoranfe: t('s.configuracao.posto.cnpjposto'),
    nometransportadoranfe: t('s.configuracao.posto.nomeposto'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="cnpjtransportadoranfe"
      detach="cnpjtransportadoranfe"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'transportadorasnfes',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Transportadoras',
        })
      }
    />
  );
}

export default Transportadora;
